<template>
  <div v-if="show" class="asd-modal-overlay">
    <div class="asd-modal">
      <div class="asd-modal-text">
        {{ question }}
      </div>
      <div class="asd-modal-controls">
        <button class="asd-btn-cancel" @click="cancel">
          Zrušit
        </button>
        <button class="asd-btn-confirm" @click="confirm">
          Budiž
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from 'CORE/bus'
import { SHOW_PROMPT, CONFIRM_PROMPT, CANCEL_PROMPT } from './prompt'

export default {
    name: 'Prompt',
    data() {
        return {
            question: '',
            show: false,
        }
    },
    mounted() {
        EventBus.$on(SHOW_PROMPT, e => {
            this.question = e.question
            this.show = true
        })
    },
    methods: {
        confirm() {
            this.show = false
            EventBus.$emit(CONFIRM_PROMPT)
        },
        cancel() {
            this.show = false
            EventBus.$emit(CANCEL_PROMPT)
        },
    },
}
</script>

<style scoped lang="scss">
.asd-modal-overlay {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5000;
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    background-color: rgba(0,0,0,0.5);
    .asd-modal {
        border: 1px solid var(--color-primary);
        background-color: var(--color-primary-inverse);
        min-width: 300px;
        border-radius: 3px;
        box-shadow: 0px 0px 3px 0px rgba(0,0,0,0.15);
        &-text {
            text-align: center;
            margin: 25px;
            font-size: 1.5rem;
        }
        &-title {
            text-align: center;
            margin: 25px;
            font-size: 1.5rem;
        }
        &-controls {
            display: flex;
            justify-content: space-evenly;
            padding: 10px;
            border-top: 1px solid var(--color-primary);
            background-color: rgba(0,0,0,0.05);
        }
    }
}
</style>

